const content: { [key: string]: string } = {
  // Information Cards
  viewLos: "View LOS",
  viewEmeraldDiamondLos: "View Emerald & Diamond LOS",
  viewWatchlist: "View Watchlist",
  viewCustomerList: "View Customer List",
  viewMyPrimeCustomerList: "View My Prime Customer List",

  // Section Dividers
  actionCenter: "Action Center",
  customerOrders: "Customer Orders",

  // Action Center Cards - Titles
  bronzeGroupTracking: "Bronze Group Tracking",
  keyProductPurchases: "Key Product Purchases",
  saqCertification: "Sponsoring Activity Qualification Report",
  whosNew: "Who's New",
  whosNewWithCustomers: "New ABO/PC Activity",
  whoOrderedThisMonth: "Who Ordered This Month",
  whosClose: "Who's Close",
  birthdays: "Birthdays",
  renewals: "Renewals",
  ssiUplineReport: "SSI Upline Report",
  nonBonusableBv: "Non-Bonusable BV",
  cvrCompliance: "CVR Compliance",
  iboOnboarding: "IBO Onboarding",
  cbrClock: "CBR Clock",
  foundersSalesIncentiveTitle: "Founders Sales Incentive Report",
  foundersSalesIncentiveTitleMobile: "FSI Tracking",

  // Action Center Cards - KPI Labels
  upForRenewal: "Up For Renewal",
  saqIncomplete: "Incomplete",
  saqCompleted: "Completed",
  abosOnSop: "ABOs on SOP",
  customersOnSop: "Customers on SOP",
  close: "Close",
  new: "New",
  withinWindow: "Within Window",
  withinWindowMobile: "In Window",
  graduated: "Graduated",
  newSaqHolders: "New SAQ Holders",
  onSop: "On SOP",
  abos: "ABOs",
  abo: "ABO",
  provisionalAbo: "PABOs",
  primeCustomers: "Prime Customers",
  customers: "Customers",
  closeToPercent: "Close to {percent}",
  birthdaysThisMonth: "This Month",
  nextMonth: "Next Month",
  inRenewalPeriod: "In Renewal Period",
  inGracePeriod: "In Grace Period",
  earlyRenewalPeriod: "In Early Renewal Period",
  onAutoRenewal: "On Auto Renewal",
  notOnAutoRenewal: "Not On Auto Renewal",
  notOnAutoRenewalMobile: "Non-Auto Renewal",
  inProgram: "In SSI Program",
  inProgramMobile: "In Program",
  outOfProgram: "Out of SSI Program",
  outOfProgramMobile: "Out of Program",
  inFsi: "In FSI Program",
  outFsi: "Out of FSI Program",

  // Customer Order Cards
  ordered: "Ordered {date}",
  customerPv: "{value} Customer PV",
  noCustomerOrders: "You have no recent customer orders.",
  viewAll: "View All",

  // Disabled State
  notAvailable: "Not Available",

  // Error State
  errorMessage: "Something went wrong.",
  tryAgain: "Try Again",

  // Empty States
  noAbosCloseToThresholds: "There are no ABOs which meet this criteria.",
  noDataForCriteria: "No ABOs meet this criteria.",
  noDataForCriteriaWithCustomers: "No ABOs or customers meet this criteria.",
  noDataForCriteriaWithCustomersMobile: "No ABOs or customers meet this criteria.",
};

export default content;
